import { SvgIconProps } from '@mui/material'
import { forwardRef } from 'react'

/**
 * Icon size variants
 */
export type IconSize = 'small' | 'medium' | 'large' | 'inherit'

/**
 * Icon component props
 */
export interface IconProps extends Omit<SvgIconProps, 'fontSize'> {
  /** Icon component from MUI icons */
  icon: React.ElementType
  /** Icon size */
  size?: IconSize
  /** Icon color */
  color?: 'primary' | 'secondary' | 'action' | 'disabled' | 'error' | 'inherit'
}

/**
 * Custom Icon component wrapper for Material UI icons
 * Provides consistent sizing and color handling
 */
export const Icon = forwardRef<SVGSVGElement, IconProps>(
  ({ icon: IconComponent, size = 'medium', color = 'inherit', ...props }, ref) => {
    return (
      <IconComponent
        ref={ref}
        fontSize={size}
        color={color}
        {...props}
      />
    )
  }
)

Icon.displayName = 'Icon'
